<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'invoice',
};
</script>

<style>
</style>
